import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import { Editor } from '@containers/DigitalAnalyst/AgentScriptEditor/Editor';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const EditorWrapper = styled.div`
  padding: 0 16px 0 0px;
`;

function AgentModePage() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <EditorWrapper>
          <Editor />
        </EditorWrapper>
      </Body>
    </PageWrapper>
  );
}

export default AgentModePage;
